import { render, staticRenderFns } from "./ProjectKanban.vue?vue&type=template&id=b417dbb0&scoped=true&"
import script from "./ProjectKanban.vue?vue&type=script&lang=js&"
export * from "./ProjectKanban.vue?vue&type=script&lang=js&"
import style0 from "./ProjectKanban.vue?vue&type=style&index=0&id=b417dbb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b417dbb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b417dbb0')) {
      api.createRecord('b417dbb0', component.options)
    } else {
      api.reload('b417dbb0', component.options)
    }
    module.hot.accept("./ProjectKanban.vue?vue&type=template&id=b417dbb0&scoped=true&", function () {
      api.rerender('b417dbb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/management/ProjectKanban.vue"
export default component.exports